import React from 'react';
import ReactPlayer from 'react-player/file';

import { PlayerWrapper } from './styled';

export const PlayerComponent = ({ playing, url, onReady }: { playing: boolean; url: string; onReady: () => void }) => {
    return (
        <PlayerWrapper>
            <ReactPlayer
                url={url}
                playing={playing}
                controls={false}
                playsinline={true}
                loop={true}
                muted={true}
                width="100%"
                height="100%"
                config={{
                    attributes: {
                        onCanPlayThrough: () => {
                            onReady();
                        },
                    },
                }}
            />
        </PlayerWrapper>
    );
};

export default PlayerComponent;
